<template>
    <div class="manage-users">
      <div class="head-title">
        <p>管理平台用户</p>
      </div>
      <div class="select">
        <div class="DataNumber" >
          <p>共{{total}}名用户</p>
        </div>
        <!-- <div class="DataNumber-buttonList" v>
          <p>已选择2条</p>
          <div class="ButtonList">
            <div class="takenOffTheShelves">下架</div>
            <div class="delete" @click="hanleDel">删除</div>
          </div>
        </div> -->
        <div class="select-input">
          <input placeholder="搜索" type="text" @keyup.enter="hanleSearch" v-model="keyword" />
          <img :src="seach" alt="" />
        </div>
      </div>
      <div class="Datasets">
        <el-table
          :data="tableData"
          style="width: 100%"
          :stripe="false"
          :row-style="{
            border: '1px solid #eee',
            borderRadius: '4px',
            marginTop: '5px',
          }"
        >
          <el-table-column label="用户姓名" width="248">
            <template slot-scope="scope" >
                <div class="nameBox">
                  <img src="../../../../assets1/关于我们_slices/地图背景.png" class="Avatar" alt="">
                  <span class="DataSpan">{{ scope.row.username }}</span>
                  <span class="permission" v-if="scope.row.role===2">超管</span>
                </div>
            </template>
          </el-table-column>
          <el-table-column prop="phone" label="手机号">

          </el-table-column>
          <el-table-column prop="company_name" label="公司名称">
            <template slot="header" slot-scope="scope">
              <div class="CompanyName-box" @click="hanleshow">
                <span>公司名称</span>
                <img src="../../../../assets1/后台/搜索.png" alt=""  class="SeachIcon"/>
                <div class="Seach-box" v-if="showSeach">
                  <div class="select-input CompanyNameSeach">
          <input placeholder="搜索" type="text" />
          <img :src="seach" alt="" />
        </div>
                </div>
              </div>
              
            </template>
          
          
          </el-table-column>
          <el-table-column>
            <template slot="header" slot-scope="scope">
              <el-dropdown>
                <span class="el-dropdown-link">
                  状态<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="item in statuList" :key="item.value">{{
                    item.name
                }}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
            <template slot-scope="scope">
              <span v-if="scope.row.status === 1">正常</span>
              <span class="dangeText" v-if="scope.row.status === 2">已冻结</span>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="GoMan(scope.row)">查看</el-button>
              <el-button type="text" size="small" v-if="scope.row.status===1">冻结</el-button>
              <el-button type="text" size="small" v-if="scope.row.status===2">恢复</el-button>
              <el-button type="text" size="small" class="dangeText" @click="hanleDelUser(scope.row)">删除用户</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination">
        <el-pagination
          :current-page="1"
          :page-sizes="[3, 5, 10]"
          :page-size="page_size"
          layout="total, prev, pager, next,  sizes,jumper"
          :total="total"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        >
        </el-pagination>
      </div>
      <DiaLog 
        :visible.sync="isDel"
        title="确认删除需求"
        content="确认删除这3条数据需求吗?"
        :type="2"
        @confirm="hanleOk"
      >
        <span>确定要删除选中的数据吗？</span>
      </DiaLog>
    </div>
  </template>
  
  <script>
  import { SearchUser } from "@/api/user";
  import { Message } from "element-ui";
  import DiaLog from "@/components/DiaLog.vue";
  import seach from "@/assets1/已发布数据集-已选_slices/搜索.png";
  import wj from "@/assets1/已发布数据集-已选_slices/编组 8.png";
  import { DeleteUser } from "@/api/user";
  export default {
    components: {
      DiaLog,
    },
    data() {
      return {
        keyword:'',
        seach,
        checkAll: false,
        wj,
        itemList: [false, false, false],
      showSeach:false,
      total:0,
      page_no:1,
      page_size:5,
        isDel: false,
        industryList: [
          {
            name: "工业制造",
            value: "1",
          },
          {
            name: "交通运输",
            value: "2",
          },
          {
            name: "金融服务",
            value: "3",
          },
          {
            name: "科技创新",
            value: "4",
          },
          {
            name: "绿色低碳",
            value: "5",
          },
          {
            name: "气象服务",
            value: "6",
          },
          {
            name: "商贸流通",
            value: "7",
          },
          {
            name: "文化旅游",
            value: "8",
          },
          {
            name: "现代农业",
            value: "9",
          },
          {
            name: "医疗健康",
            value: "10",
          },
          {
            name: "应急管理",
            value: "11",
          },
          {
            name: "城市治理",
            value: "12",
          },
        ],
        statuList: [
          {
            name: "正常",
            value: 1,
          },
          {
            name: "已冻结",
            value: 2,
          },
        ],
        tableData: [
          {
            data: "赵四",
            industryClassification: "13281002769",
            date: "xxx数字科技有限公司",
            type: 2,
            permission:1
          },
        
       
        ],
      };
    },
    computed: {},
    created(){
      this.hanleSearch()
    },
    watch: {
      itemList(newValue) {
        const istrue = Array.from(newValue).every((item) => {
          return item === true;
        });
        if (istrue === true) {
          this.checkAll = true;
        } else {
          this.checkAll = false;
        }
      },
    },
    methods: {
    async  hanleDelUser(item){
        console.log(item,'item');
    const res=await  DeleteUser(item.id)
    console.log(res,'res');
    Message.success('删除成功')
    this.hanleSearch()
        
      },
      handleSizeChange(val) {
        console.log(val,'val');
        this.page_size = val;
        this.hanleSearch();
      },
      handleCurrentChange(val) {
        console.log(val,'val');
        
        this.page_no = val;
        this.hanleSearch();
      },
    async  hanleSearch(){
      const res=await SearchUser({
        page_no:this.page_no,
        page_size:this.page_size,
        keyword:this.keyword
      })
      this.total=res.total
      this.tableData=res.users
      console.log(res,'res');
      
      },
      hanlecheck() {
        if (this.checkAll) {
          this.itemList.forEach((item, index) => {
            this.itemList[index] = true;
          });
        } else {
          this.itemList.forEach((item, index) => {
            this.itemList[index] = false;
          });
        }
      },
      hanleshow(){
        this.showSeach=!this.showSeach
      },
      hanleDel() {
        this.isDel = true;
      },
      hanleOk() {
        this.isDel = false;
      },
      GoMan(item){
        console.log(item,'item');
        
        this.$router.push({
          path:'/getUserInfo',
          query:{
            ...item
          }
        })
        
      }
    },
  };
  </script>
  
  <style scoped> 
  .CompanyNameSeach{
    background-color: #F5F5F5 !important;
  }
  .CompanyNameSeach input{
    color:#CCCCCC !important ;

  }
  .Seach-box{
    padding: 12px;
    position: absolute;
    left: 0;
    bottom: -75px;
    box-shadow: 0px 2px 12px 0px rgba(0,0,0,0.1);
border-radius: 8px;
    z-index: 1000;
    background-color: #fff;
  }
  .SeachIcon{
    margin-left: 4px;
  }

  .CompanyName-box{
    display: flex;
    align-items: center;
    cursor: pointer;
    position: relative;
  }

  .dangeText{
    font-family: Regular;
    color:#e92424 ;
  }
  .permission{
    font-size: 10px;
    font-family: Regular;
    color: rgba(255, 208, 0, 1);
    background-color: rgba(255, 208, 0, 0.12);
    border-radius: 4px;
    display: inline-block;
    height: auto;
    line-height: normal !important;
    margin-left: 8px;
    padding: 4px;
  }
  .nameBox{
    display: flex;
    align-items: center;
  }
  .Avatar{
    width: 20px;
    height: 20px;
    border-radius: 50%;
    object-fit: cover;
    margin-right: 8px;
  }
  .DataNumber-buttonList {
    display: flex;
    line-height: 30px;
  }
  .DataNumber-buttonList p {
    margin-right: 20px;
    font-family: Medium;
    font-size: 14px;
    color: #666;
  }
  .ButtonList {
    display: flex;
  }
  .takenOffTheShelves {
    width: 80px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    border: 1px solid #cccccc;
    border-radius: 4px;
    font-size: 14px;
    font-family: Regular;
    color: #838690;
    margin-right: 20px;
  }
  .delete {
    width: 80px;
    height: 30px;
    background-color: red;
    text-align: center;
    line-height: 30px;
    border-radius: 4px;
    font-size: 14px;
    font-family: Regular;
    color: #fff;
  }
  .DataNumber {
    height: 36px;

    line-height: 36px;
    font-family: Medium;
    font-size: 14px;
    color: #666666;
  }
  ::v-deep .el-table__body {
    /* -webkit-border-horizontal-spacing: 13px;   */
    -webkit-border-vertical-spacing: 13px;
  }
  .border1 {
    border: 1px solid #000;
    color: red;
  }
  .DataSpan {
    white-space: nowrap;
    overflow: hidden;
    /* width: 188px; */
    display: inline-block;

    text-overflow: ellipsis;
 

  }
  ::v-deep .number.active {
    background-color: #0d53ff;
    color: #fff;
    box-sizing: border-box;
  }
  ::v-deep .el-pager .more::before {
    line-height: 18px;
  }
  ::v-deep .el-pagination {
    font-size: 12px;
    font-family: Regular;
    box-sizing: border-box;
    width: 100%;
    position: absolute;
    bottom: -30px;
    left: 120px;
  }
  ::v-deep .el-pager li.active + li {
    border-left: 1px solid #d9d9d9;
  }
  ::v-deep .el-pager li {
    padding: 8px 10px;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    width: auto;
    line-height: normal;
    height: auto;
    margin-right: 8px;
    color: #666666;
    box-sizing: border-box;
  }
  ::v-deep .el-pager li:last-child {
    margin-right: 0;
  }
  .delbtn {
    background-color: #e92424;
    color: #fff;
  }
  .updatabtn {
    color: #838690;
    background-color: #fff;
  }
  .btn-list {
    position: absolute;
    top: 50%;
    right: 0px;
    transform: translateY(-50%);
  }
  .btn-list button {
    font-size: 14px;
    width: 80px;
    height: 30px;
    font-family: Regular;
    border: 1px solid #cccccc;
    border-radius: 4px;
    margin-right: 15px;
  }
  .conten-box-p {
    margin-bottom: 12px;
    font-size: 14px;
    line-height: 20px;
  }
  .conten-box-title {
    margin-bottom: 4px;
    font-size: 16px;
    font-family: Medium;
  }
  .item-check {
    margin-left: 20px;
  }
  .img {
    width: 95px;
    height: 95px;
    border-radius: 6px;
    background-color: #d8d8d8;
    flex-shrink: 0;
    margin-left: 20px;
    margin-right: 12px;
  }
  .iconlist-item {
    display: flex;
    font-size: 12px;
    line-height: 13px;
    margin-right: 25px;
  }
  .iconlist-item img {
    width: 13px;
    height: 13px;
    object-fit: cover;
    margin-right: 3px;
  }
  .content-iconList {
    display: flex;
  }
  .item-content {
    width: 500px;
    display: flex;
  }
  .Datasets-item {
    width: 100%;
    height: 135px;
    border-radius: 4px;
    border: 1px solid #eee;
    display: flex;
    align-items: center;
    position: relative;
    margin-bottom: 8px;
  }
  ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #0d53ff;
  }
  .checkbox-All p {
    margin-left: 20px;
  }
  .checkbox-All {
    display: flex;
    flex-shrink: 0;
  
    align-items: center;
  }
  .checkbox-All {
    display: flex;
    /* color: #0D53FF; */
  }
  .Datasets-head {
    display: flex;
    justify-content: space-between;
    padding: 19px 20px;
    background-color: #f7f7f7;
    border-radius: 4px;
    margin-bottom: 12px;
  }
  .Datasets {
    margin-top: 33px;
  }
  .select-input {
    width: 164px;
    height: 36px;
    border-radius: 4px;
    border: 1px solid #d9d9d9;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    color: #cccccc;
    font-family: Regular;
  }
  .select-input input {
    width: 107px;
    height: 18px;
    margin-right: 17px;
    outline: none;
    border: none;
  }
  .select-input input::placeholder {
    font-family: Regular;
  }
  .active {
    color: #0d53ff;
  }
  .select-list p.active::before {
    content: "";
    position: absolute;
    left: 0;
    bottom: -10px;
    width: 100%;
    height: 2px;
    background-color: #0d53ff;
  }
  .select-list p {
    margin-right: 50px;
    position: relative;
    font-size: 14px;
  }
  .select-list {
    display: flex;
    flex-shrink: 0;
  }
  .select {
    display: flex;
    flex-shrink: 0;
    justify-content: space-between;
  }
  .manage-users {
    height: 100%;
    box-sizing: border-box;
    padding: 24px;
    font-family: Regular;
    position: relative;
  }
  .head-title {
    font-size: 24px;
    font-family: Medium;
    margin-bottom: 24px;
  }
  </style>
  <style>
  .Datasets .el-table th.el-table__cell{
    overflow:visible;
  }
  .Datasets {
    border: none !important;
  }
  .Datasets .el-table .cell{
    overflow:visible;
  }
  
  .Datasets .el-table__header-wrapper{
    overflow:visible;
  }
  .Datasets .el-table {
    border: none !important;
  }
  
  .Datasets .el-table::before {
    display: none !important;
  }
  
  .Datasets .el-table__header-wrapper {
    border: none !important;
  }
  
  .Datasets .el-table__header th {
    border: none !important;
    background-color: transparent !important;
  }
  
  .Datasets .el-table__header .cell {
    border: none !important;
    font-family: Medium;
    font-size: 12px;
    color: #000;
  }
  .Datasets .el-table__header .cell .el-dropdown {
    font-family: Medium;
    font-size: 12px;
    color: #000;
  }
  .Datasets .el-table__body .cell {
    border: none !important;
    font-family: Regular;
    font-size: 12px;
    color: #666666;
  }
  .Datasets .el-table__header .has-gutter tr {
    background-color: #f8f8f8;
  }
  
  .Datasets .el-table__header .el-checkbox__inner {
    display: none;
  }
  
  .Datasets .el-table__header tr {
    border: none !important;
  }
  
  .Datasets .el-table__body td {
    height: 40px !important;
    line-height: 40px !important;
    padding: 0 !important;
    border: 1px solid #eee !important;
  }
  
  /* 第一列只移除右边框，添加左边圆角 */
  .Datasets .el-table__body td:first-child {
    border-right: none !important;
    border-top-left-radius: 4px !important;
    border-bottom-left-radius: 4px !important;
  }
  
  /* 中间列只添加上下边框 */
  .Datasets .el-table__body td:not(:first-child):not(:last-child) {
    border-top: 1px solid #eee !important;
    border-bottom: 1px solid #eee !important;
    border-left: none !important;
    border-right: none !important;
  }
  
  /* 最后一列不添加左边框，添加右边圆角 */
  .Datasets .el-table__body td:last-child {
    border-top: 1px solid #eee !important;
    border-bottom: 1px solid #eee !important;
    border-right: 1px solid #eee !important;
    border-left: none !important;
    border-top-right-radius: 4px !important;
    border-bottom-right-radius: 4px !important;
  }
  
  /* 移除表格默认边框 */
  .Datasets .el-table__body-wrapper {
    border: none !important;
  }
  
  .Datasets .el-table__inner-wrapper {
    border: none !important;
  }
  
  .pagination .el-pagination {
    font-family: Regular;
    font-size: 12px;
    color: #666666;
  }
  .pagination .el-pagination .el-pager .number {
    font-family: Regular;
    font-size: 12px;
    color: #666666;
  
    /* height: 28px; */
  }
  .pagination .el-pagination .el-pager .active {
    font-family: Regular;
    font-size: 12px;
    color: #fff;
    /* width: 28px; */
    /* height: 28px; */
  }
  .pagination .el-pagination .el-pagination__total {
    margin-top: 3px;
  }
  .pagination .el-pagination .el-icon.el-icon-arrow-left {
    margin-top: 1px;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    padding: 9.5px 9.5px;
  }
  .pagination .el-pagination .el-icon.el-icon-arrow-right {
    margin-top: 1px;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    padding: 9.5px 9.5px;
  }
  .pagination .el-pagination .el-input.el-input--mini.el-input--suffix {
    margin-top: 3px;
  }
  .pagination .el-pagination .el-pagination__jump {
    margin-top: 3px;
  }
  </style>
  